import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

/**
 * Should the user's refresh token expire during a session, this dialog will popup to inform them. They will then be logged out.
 */
@Component({
    selector: 'app-expiration-dialog',
    templateUrl: './expiration-dialog.component.html',
    styleUrls: ['./expiration-dialog.component.css'],
    standalone: false
})
export class ExpirationDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ExpirationDialogComponent>) { }

  ngOnInit(): void {
  }

}
